import { render, staticRenderFns } from "./catalog.vue?vue&type=template&id=c2c4db52&"
import script from "./catalog.vue?vue&type=script&lang=js&"
export * from "./catalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports